<span
  class="link"
  (click)="$event.stopPropagation(); openUrl()"
  [ngClass]="{
    bold: model?.style?.bold,
    italic: model?.style?.italic,
    strike: model?.style?.strike
  }"
  [innerHtml]="(model.text ? model.text : model.onClick?.url) | richTextFormatted | highlight: highlights:highlightStyle"
  [style.background-color]="theme === 'light' ? model?.style?.backgroundColor?.lightTheme : model?.style?.backgroundColor?.darkTheme"
  [style.color]="theme === 'light' ? model?.style?.textColor?.lightTheme : model?.style?.textColor?.darkTheme"
>
</span>
